import axios from 'axios';
import { API_SERVER_HOST } from '../Config';
import jwtAxios from '../util/jwtUtil';

const host = `${API_SERVER_HOST}/api/member`;

export const loginPost = async (loginParam) => {
  const header = { headers: { 'Content-Type': 'x-www-form-urlencoded' } };

  const form = new FormData();
  form.append('username', loginParam.id);
  form.append('password', loginParam.pw);

  const response = await axios.post(`${host}/login`, form, header);
  return response.data;
};

export const isTokenCheckedPost = async (memberParam) => {
  const response = await jwtAxios.post(`${host}/isTokenCheck`, memberParam);
  return response;
};

////////////////// 수정예정

export const getMemberList = async (memberId, searchTerm, initialConsonant, sport, page, size) => {
  const header = { headers: { 'Content-Type': 'x-www-form-urlencoded' } };
  if(initialConsonant === "즐겨찾기")
    initialConsonant = "favorite";
  const response = await jwtAxios.get(`${host}/getMemberList?memberId=${memberId}&searchTerm=${searchTerm}&initialConsonant=${initialConsonant}&sport=${sport}&page=${page}&size=${size}`, header);
  return response;
};

export const getFavoriteMemberNumbers = async (memberId) => {
  const header = { headers: { 'Content-Type': 'x-www-form-urlencoded' } };

  const response = await jwtAxios.get(`${host}/getFavoriteMemberNumbers?memberId=${memberId}`, header);
  return response;
};

export const getMemberForNumber = async (memberNumber) => {
  const header = { headers: { 'Content-Type': 'x-www-form-urlencoded' } };

  const response = await jwtAxios.get(`${host}/getMemberForNumber?memberNumber=${memberNumber}`, header);
  return response;
};

export const removeFavoriteNumber = async (memberId, favoriteMemberNumber) => {
  const header = { headers: { 'Content-Type': 'application/json' } };

  // memberId와 memberNumber를 쿼리 파라미터로 추가
  const response = await jwtAxios.delete(`${host}/removeFavoriteNumber`, {
      ...header,
      params: { memberId, favoriteMemberNumber },
  });
  return response;
};
export const addFavoriteNumber = async (memberId, favoriteMemberNumber) => {
  const formData = new FormData();
  formData.append('favoriteMemberDTO', new Blob([JSON.stringify({
    memberId: memberId,
    favoriteMemberNumber: favoriteMemberNumber
  })], { type: 'application/json' }));

  const response = await jwtAxios.post(`${host}/addFavoriteNumber`, formData);
  return response;
};